module.exports = __webpack_public_path__ + "static/BLOG_230830_What-is-prompt-engineering_-a61a7989abf1ec388b565c04d4930234.webp";